import { Grid } from '@mui/material';
import { Button } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface FooterButtonProps {
  onClickNext: () => void;
  onClickBack: () => void;
}

const FooterButton: React.FC<FooterButtonProps> = ({
  onClickBack,
  onClickNext,
}) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Grid container spacing={2} mb={'1rem'}>
        <Grid size={1.5}>
          <Button
            variant="outlined"
            fullWidth
            sx={{ justifyContent: 'center' }}
            onClick={onClickBack}
            startIcon={
              <ArrowBackIosSharpIcon
                style={{
                  verticalAlign: 'middle',
                  fontSize: '16px',
                }}
              />
            }
          >
            {/* 診断結果の修正(検査画面へ戻る) */}
            {t('BTN_BACK')}
          </Button>
        </Grid>
        <Grid size={9} />
        <Grid size={1.5}>
          <Button
            variant="contained"
            fullWidth
            sx={{ justifyContent: 'center' }}
            onClick={onClickNext}
            endIcon={
              <ArrowForwardIosSharpIcon
                style={{
                  verticalAlign: 'middle',
                  fontSize: '16px',
                }}
              />
            }
          >
            {t('BTN_NEXT')}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default FooterButton;
